import { type MotionValue } from 'motion/react'
import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type ProfileViewModel } from '@/features/iam/users/ProfileViewModel'
import { ProfileHeader } from '@/features/iam/users/components/ProfileHeader'

export interface ProfileHeaderContainerProps {
  viewTitle: string
  scrollOffset: MotionValue<number>
  vm: ProfileViewModel
  tabBar?: ReactNode
  saveButton?: ReactNode
}

export const ProfileHeaderContainer = observer(function ProfileHeaderContainer({
  scrollOffset,
  viewTitle,
  vm,
  saveButton,
  tabBar,
}: ProfileHeaderContainerProps) {
  return (
    <ProfileHeader
      viewTitle={viewTitle}
      scrollOffset={scrollOffset}
      displayName={vm.member.displayName}
      avatar={{
        avatar: vm.member.avatar,
        avatarFallback: vm.member.avatarFallback,
        displayName: vm.member.displayName,
      }}
      isAvatarUploading={vm.uploadNewAvatar.pending}
      onSelectNewAvatarFile={vm.uploadNewAvatar}
      tabBar={tabBar}
      saveButton={saveButton}
    />
  )
})
